import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../styles/sarv-system.css";
import "../../styles/Hero.css";
import { trackCTAClick } from "../../utils/analytics";
import AtlasGraphBackdrop from "../home/AtlasGraphBackdrop";
import Typewriter from "../home/Typewriter";

// Homepage hero.
//
// The background is the knowledge graph itself, drifting — built from our own
// data rather than stock footage, and 24.6 kB of baked JSON instead of the
// 6.8 MB hero.mp4 every visitor used to download. The previous video
// implementation is in git if it needs to come back.
//
// Type is deliberately enormous and tightly tracked (see .sv-display in
// sarv-system.css). The first typewriter phrase is rendered whole so the
// prerendered HTML and React's first client render match under hydrate().

// phrases[0] is what social scrapers and the prerenderer capture, so it has to
// stand alone as the headline. Each completes "Understand what medicinal
// plants ..." and each is substantiated further down the page — nothing here is
// a mood word.
//
// Note what is deliberately NOT claimed: not "all backed by science". 40,890 of
// the 64,061 relationships in the graph are traditional use with no science
// reviewed, and saying otherwise would break the one promise the whole site is
// built on. "What the research actually says" is the honest form of the same
// claim, and it is the stronger one — it survives being checked.
const PHRASES = [
  "do to your body",
  "are right for yours",
  "do when combined",
];

const Header = () => {
  const navigate = useNavigate();

  const startTrial = () => {
    trackCTAClick("Get Started", "Homepage Hero");
    navigate("/start");
  };

  return (
    <section className="sv-dark hero">
      <AtlasGraphBackdrop intensity={0.9} density={104} />

      <div className="sv-wrap hero__inner">
        <p className="sv-eyebrow">
          1,056 plants · 1,136 documented actions · graded against the research
        </p>

        <h1 className="sv-display hero__title">
          Understand what medicinal plants
          <br />
          <Typewriter phrases={PHRASES} />
        </h1>

        {/* Plain language on purpose. "Knowledge graph" and "graded
            relationships" are what we built; they are not what a reader
            searching "what does ashwagandha actually do" understands. */}
        <p className="sv-lede hero__lede">
          Not a list of remedies. A map of what each plant does in the body,
          which ones fit your biology rather than the average person's, and how
          they behave together — every claim graded against the published
          research, including where there isn't any.
        </p>

        <div className="hero__actions">
          <Link
            to="/atlas"
            className="sv-btn sv-btn--primary"
            onClick={() => trackCTAClick("hero_explore_atlas", "home-hero")}
          >
            Explore the Atlas
          </Link>
          <button
            type="button"
            className="sv-btn sv-btn--ghost"
            onClick={startTrial}
          >
            Get your plan
          </button>
        </div>

        <ul className="hero__legend">
          <li>
            <span className="hero__dot hero__dot--herb" /> Herb
          </li>
          <li>
            <span className="hero__dot hero__dot--condition" /> Condition
          </li>
          <li>
            <span className="hero__dot hero__dot--action" /> Action
          </li>
          <li className="hero__legend-note">
            line weight = strength of evidence
          </li>
        </ul>
      </div>
    </section>
  );
};

export default Header;
